import { BookingModel } from '@shared/booking-feature';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace BookingActions {
    export class SetSelectedBooking {
        static readonly type = '[Booking] Set Selected Booking';
        constructor(public booking: BookingModel) {}
    }

    export class ClearSelectedBooking {
        static readonly type = '[Booking] Clear Selected Booking';
    }
}
